import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  setAccount(profile) {
    const account = JSON.stringify(profile);
    sessionStorage.setItem('account', account);
  }
  getAccount() {
    return JSON.parse(sessionStorage.getItem('account'));
  }
}
